/**
 * Shared variant-availability marking (Horizon-style).
 *
 * Marks an option value as sold-out when there is no AVAILABLE variant that has
 * that value together with the currently-selected values of the other options.
 * Consumers (product cards, PDP, quick view) build `groups` from their own
 * markup and call apply(); the helper only computes and toggles the marker.
 *
 *   groups: [{ selectedValue, items: [{ value, el?, mark?(soldOut) }] }]  // in option order
 *   variants: Shopify variant objects with `.options` (array) and `.available`
 */
window.VariantAvailability = {
  isAvailable: function (variants, selected, optionIndex, value) {
    return variants.some(function (v) {
      if (!v.available) return false;
      if (v.options[optionIndex] !== value) return false;
      for (var j = 0; j < selected.length; j++) {
        if (j === optionIndex || selected[j] == null) continue;
        if (v.options[j] !== selected[j]) return false;
      }
      return true;
    });
  },

  apply: function (variants, groups, soldOutClass) {
    if (!variants || !variants.length || !groups) return;
    var self = this;
    var selected = groups.map(function (g) { return g.selectedValue; });
    groups.forEach(function (g, i) {
      g.items.forEach(function (item) {
        var soldOut = !self.isAvailable(variants, selected, i, item.value);
        if (item.el && soldOutClass) item.el.classList.toggle(soldOutClass, soldOut);
        if (typeof item.mark === 'function') item.mark(soldOut);
      });
    });
  }
};
